import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Projects = () => {
    const [projects, setProjects] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetch('projects.json')
            .then(res => res.json())
            .then(data => setProjects(data))
    }, []);

    // const handleProjectDetails = id => {
        
    // }

    return (
        <div className='border mt-6 p-2'>
            <h2 className='text-3xl font-semibold mt-1'>My Projects</h2>

            <div className='grid lg:grid-cols-3 text-accent mt-5 lg:ml-16'>
                {
                    projects.map(project => <>
                        <div class="card lg:w-96 w-full mb-3 bg-secondary shadow-xl">
                            <figure><img className='w-full' src={project.img} alt="Album" /></figure>
                            <div class="card-body">
                                <h2 class="text-2xl font-bold">{project.name}</h2>
                                <div>
                                    <>
                                        <a href={project.live} target='_blank'>Live Site</a><span className='font-bold mx-1'>||</span>
                                        <a href={project.client} target='_blank'>GitHub Client</a>
                                    </>
                                    {
                                        project.server ?
                                            <>
                                                <span className='font-bold mx-1'>||</span>
                                                <a href={project.server} target='_blank'>GitHub Server</a>
                                            </>
                                            :
                                            ''

                                    }
                                    <div>
                                        <button onClick={() => navigate(`/project/${project._id}`)} className='btn px-10 mt-2' to='/'>See Details</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>)
                }
            </div>
        </div>
    );
};

export default Projects;